// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import "babel-polyfill"; //兼容IE浏览器
import iView from "iview"; // 导入组件库
import "./style/index.scss";
// 引用工具文件
import utils from "./utils/index.js";
import VConsole from "vconsole"; // 引入vconsole
// 引入luckyCanvas抽奖插件
import VueLuckyCanvas from "@lucky-canvas/vue";
Vue.use(VueLuckyCanvas);
import { config } from "./commons/config.js";
import { Popup, Swipe, SwipeItem, Button } from "vant";

Vue.use(Button)
Vue.use(Popup);
Vue.use(Swipe);
Vue.use(SwipeItem);
if (config.env !== "pro") {
  // 正式环境不能引入vconsole
  Vue.prototype.$vconsole = new VConsole(); // 使用vconsole
}
//判断终端
const browser = {
  versions: (function() {
    const u = navigator.userAgent,
      app = navigator.appVersion;
    return {
      //移动终端浏览器版本信息
      trident: u.indexOf("Trident") > -1, //IE内核
      presto: u.indexOf("Presto") > -1, //opera内核
      webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
      gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
      iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf("iPad") > -1, //是否iPad
      webApp: u.indexOf("Safari") == -1 //是否web应该程序，没有头部与底部
    };
  })(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
};
Vue.prototype.$browser = browser;

//比例
let width = document.documentElement.clientWidth; //获取屏幕的宽度
let height = document.documentElement.clientHeight; //获取屏幕的高度
width = browser.versions.mobile ? width : width - 20;
width = width > 750 ? 750 : width;
let mainP = width / 750,
  contentP = width / 690;
Vue.prototype.$pScreen = {
  width: width,
  height: height,
  mainP: mainP,
  mainW: 750 * mainP + "px",
  contentP: contentP,
  radioH: 80 * mainP + "px",
  radioW: 690 * mainP + "px",
  textW: 690 * mainP + "px",
  textH: 78 * mainP + "px",
  textS: 24 * mainP + "px",
  titleS: 28 * mainP + "px"
};

// 将工具方法绑定到全局
Vue.prototype.$utils = utils;
// 引用API文件
import api from "./api/axios.js";
// 将API方法绑定到全局
Vue.prototype.$api = api;

Vue.config.productionTip = false;

import { $memberMixSwitch } from "./api/config.js";
Vue.prototype.$memberMixSwitch = $memberMixSwitch;

//引入国际化
import VueI18n from "vue-i18n";
import ien from "iview/dist/locale/en-US";
import izh from "iview/dist/locale/zh-CN";
import en from "./locale/en-US";
import zh from "./locale/zh-CN";
Vue.use(VueI18n);
const messages = {
  "en-US": Object.assign(en, ien),
  "zh-CN": Object.assign(zh, izh)
};
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: "zh-CN", // set locale
  messages // set locale messages
});
//引入iview和设置国际化
Vue.use(iView, { i18n: (key, value) => i18n.t(key, value) });

import ihlp from "./ihlp";
//添加项目中自定义全局组件
Vue.use(ihlp);
// 注册微信开放标签
Vue.config.ignoredElements = ["wx-open-launch-weapp", "wx-open-subscribe"];

// 增加灰度的路由入口路径判断
let routerLocation = window.location.href;
let routerBase = routerLocation.indexOf("/hdbeta/") > -1 ? "/hdbeta/" : "/hd/";
Vue.prototype.$routerBase = routerBase;

const getPermSubstr = function(ser) {
  let state = store.state;
  let service = state.userInfo.userPermission.service;
  let substr = ser.replace("v-perm:", "");
  substr = substr.replace(/SER./g, "service.indexOf('");
  substr = substr.replace(/\|\|/g, "')>-1||");
  substr = substr.replace(/\&\&/g, "')>-1&&");
  substr += "')>-1";
  return eval(substr);
};
//全局方法，判断登录的用户是否有权限
Vue.prototype.$perm = function(ser) {
  return getPermSubstr(ser);
};
// 全局权限控制指令 `v-perm`，使用方式，在任意标签使用，例如：<Button type="ghost" v-perm:SER.permtest001&&SER.permtest002 >
Vue.directive("perm", {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function(el, binding) {
    let rawName = binding.value || binding.rawName;
    let substr = getPermSubstr(rawName);
    try {
      if (!substr) {
        // 删除元素
        el.remove();
      }
    } catch (error) {
      console.error("权限点配置错误：" + rawName);
      // console.error(error)
    }
  }
});

const routerValidPerm = function(to, from, next) {
  const path = to.path,
    href = path.replace("/", "");
  const menu = store.getters["menu/getMenuByHref"](href || to.name) || {};
  const permStr = menu.perm;
  //没权限不跳转
  if (permStr && !getPermSubstr(permStr)) return false;
  const islogin = store.state.userInfo.islogin;
  if (islogin) {
    const layoutTab = store.state.base.layoutTabRef;
    layoutTab && layoutTab.setActiveMenu && layoutTab.setActiveMenu(to);
  }
  next();
};

//路由跳转前
router.beforeEach((to, from, next) => {
  if (to.path === from.path) {
    store.commit("base/setIsRouterAlive", false);
    setTimeout(() => store.commit("base/setIsRouterAlive", true), 300);
  }
  //如果路由不需要登录，则直接跳转，并且切换为home版型
  if (to.meta.isNotPerm) {
    store.commit("base/setLayoutName", "home");
    next();
  } else {
    //如果没有获取到用户权限，则先获取权限在判断是否可以跳转
    const userInfo = store.state.userInfo,
      islogin = userInfo.islogin;
    if (!islogin) {
      const pse = store.getters["userInfo/getIsloginPromise"];
      pse.then(() => {
        routerValidPerm(to, from, next);
      });
      return false;
    } else {
      routerValidPerm(to, from, next);
    }
  }

  if (window._hmt) {
    if (to.path) {
      window._hmt.push(["_trackPageview", "/hd" + to.fullPath]);
    }
  }
  next();
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  iView,
  ihlp,
  components: { App },
  template: "<App/>"
});

const _hmt = _hmt || [];
window._hmt = _hmt; // 修改为window 全局变量
(function() {
  const hm = document.createElement("script");
  // 测试环境
  hm.src = "https://hm.baidu.com/hm.js?4d54999f2f0a38dded80d6cc71ab8123";

  //生产环境
  // hm.src = "https://hm.baidu.com/hm.js?b9083a1a44fc524900fb579deec01d4b";
  const s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();



// WEBPACK FOOTER //
// ./src/main.js